import { createApp } from 'vue'
import Antd from 'ant-design-vue'
import App from './App.vue'
import 'ant-design-vue/dist/reset.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'
import { faRotateRight, faTableCellsLarge, faArrowsUpToLine, faGear, faFileExport, faList } from '@fortawesome/free-solid-svg-icons'
import router from './router'

// 设置网站标题
document.title = '迈睿达制造供应链管理平台'

library.add(faRotateRight, faTableCellsLarge, faArrowsUpToLine, faGear, faFileExport, faList)

const app = createApp(App)
app.use(Antd)
app.use(router)
app.component('font-awesome-icon', FontAwesomeIcon)
app.component('font-awesome-layers', FontAwesomeLayers)
app.component('font-awesome-layers-text', FontAwesomeLayersText)
app.mount('#app') 